import { PopulatedCalendarEvent } from "../../../api/calendarEvent";
import klydoApiClient, {
  GetCalendarEventKlydosInput,
} from "../../../api/klydo";
import useKlydoQuery from "../../../components/hooks/useKlydoQuery";

const normalizeParams = (params: GetCalendarEventKlydosInput) => {
  return {
    country: params.country || undefined,
    year: params.year,
    month: params.month,
    day: params.day || undefined,
    state: params.state || undefined,
  };
};

const createCalendarEventKlydosQueryKey = (
  params: GetCalendarEventKlydosInput,
) => {
  const normalized = normalizeParams(params);
  return [
    "calendar-event-klydos",
    normalized.country,
    normalized.year,
    normalized.month,
    normalized.day,
    normalized.state,
  ].filter((param) => param !== undefined);
};

const useCalendarEventKlydos = ({
  country,
  year,
  month,
  day,
  state,
  enabled = false,
}: GetCalendarEventKlydosInput & { enabled?: boolean }) => {
  const normalizedParams = normalizeParams({
    country,
    year,
    month,
    day,
    state,
  });
  const queryKey = createCalendarEventKlydosQueryKey(normalizedParams);

  return useKlydoQuery<PopulatedCalendarEvent[]>({
    queryKey,
    queryFn: async () => {
      const request = normalizedParams;
      const response = await klydoApiClient.getCalendarEventKlydos(request);

      return response.map((item) => ({
        ...item.calendarEvent,
        klydos: item.klydos || [],
      }));
    },
    enabled: enabled && !!normalizedParams.year && !!normalizedParams.month,
    retry: 1,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    staleTime: Infinity,
    gcTime: Infinity,
  });
};

export default useCalendarEventKlydos;
